export const useBrowserPrint = () => {
    const onBrowserPrint = () => window.print();
    return {
        onBrowserPrint,
    };
};
